<div
  class="slider"
  [ngStyle]="{ height: height + 30 + 'px' }"
  *ngIf="ready"
  #slider
  (scroll)="scroll($event)"
>
  <app-cooking-story-post
    *ngFor="let recipe of recipes; let index = index; let last = last"
    [post]="recipe"
    [ready]="ready"
    [activated]="activated[index] == true"
    [last]="last"
    [showTitle]="false"
    [slide]="true"
    [width]="width"
    [height]="height"
    [showName]="!suggest"
    [showTitle]="suggest"
    [kitchen]="suggest"
  ></app-cooking-story-post>
</div>
<div class="slider loading-slider" *ngIf="!ready" #slider>
  <div class="slider-loading-holder" *ngFor="let index of garr(10)">
    <ngx-skeleton-loader
      animation="pulse"
      class="slider-text-loader"
    ></ngx-skeleton-loader>
    <ngx-skeleton-loader
      animation="pulse"
      class="slider-text-loader2"
    ></ngx-skeleton-loader>
    <ngx-skeleton-loader
      animation="pulse"
      [theme]="{
        margin: 'auto',
        height: '148px',
        background: 'rgb(216, 216, 216)',
        'border-radius': '24px'
      }"
    ></ngx-skeleton-loader>
  </div>
</div>
